import { levelConfig } from './level-config';
import { InnerCalendarContainer } from './inner-calendar-container';
import { EventTracker } from './event-tracker';

function init() {
    // no right click context menu!!
    window.addEventListener("contextmenu", e => e.preventDefault());

    const innerCalendarContainer = new InnerCalendarContainer(levelConfig);

    const solvedText = document.querySelector('.solved-text');
    solvedText.setAttribute('data-solved-text-status', 'unsolved');

    // solvedHeader
    const headerH1 = document.querySelector('h1');
    headerH1.textContent = levelConfig.monthInfo.displayName;

    //eventTracker...
    const eventTracker = new EventTracker();

    let onSolvedFunc = function() {
        innerCalendarContainer.disableInteractions();

        solvedText.setAttribute('data-solved-text-status', 'solved');

        // eventTracker..disableInteractions...
        eventTracker.disableButtons();
    }

    innerCalendarContainer.onSolvedFunc = onSolvedFunc;
}

window.onload = init;